import { render, staticRenderFns } from "./CajaMensualDelete.vue?vue&type=template&id=597d1984"
import script from "./CajaMensualDelete.vue?vue&type=script&lang=js"
export * from "./CajaMensualDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports